import type { ITableSorting } from '@model/tableSorting';

export const initialSorting: ITableSorting = {
  id: '',
  desc: false,
};
